import React, { useState } from 'react';
import { Search as SearchIcon } from '@material-ui/icons';
import { InputBase } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { fade, makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    height: '40px',
    borderRadius: theme.shape.borderRadius,
    marginLeft: 0,
    minWidth: '100%'
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    height: '100%',
    width: '100%'
  },
  inputInput: {
    border: '2px solid #C4CDCE',
    borderRadius: '4px',
    height: '100%',
    padding: 0,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    '&:focus': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'

    },
    [theme.breakpoints.up('md')]: {
      minWidth: '100%',
      '&:focus': {
        minWidth: '100%'
      }
    },
    [theme.breakpoints.up('lg')]: {
      width: '90%',
      '&:focus': {
        width: '100%'
      }
    },
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%'
    }
  }

}));

const SearchByText = ({ action, changeStyles }) => {
  const classes = useStyles();
  const [textValue, setTextValue] = useState('');
  const { t } = useTranslation();

  const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const getTextValue = (keyword) => keyword ? removeAccents(keyword).toLowerCase() : null;

  const onKeywordChange = (event) => {
    const keywordVal = getTextValue(event.target.value);
    const payload = { text: keywordVal };
    setTextValue(keywordVal);
    action(payload);
  };

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon style={{ opacity: '50%' }} />
      </div>
      <InputBase
        id={'text-filter'}
        inputProps={{ 'aria-label': 'search' }}
        value={textValue || ''}
        onChange={onKeywordChange}
        placeholder={!changeStyles ? t('searchToolbar:search') : t('bundleListView:searchByDocumentText')}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput
        }}
        autoFocus
      />
    </div>
  );
};

SearchByText.propTypes = {
  action: PropTypes.func.isRequired
};

export default SearchByText;
